import React, { type ReactNode } from "react";

export function ReportSection({
  id,
  title,
  hint,
  children,
}: {
  id: string;
  title: string;
  hint?: string | null;
  children: ReactNode;
}) {
  return (
    <section id={id} className="scroll-mt-6 space-y-3">
      <div>
        <h2 className="font-heading text-lg font-semibold tracking-tight">{title}</h2>
        {hint ? <p className="mt-1 text-sm text-foreground/75">{hint}</p> : null}
      </div>
      {children}
    </section>
  );
}

export function ReportFrame({ children }: { children: ReactNode }) {
  return (
    <div className="space-y-6 rounded-[0.75rem] border border-border bg-background p-4 text-foreground sm:p-6">
      {children}
    </div>
  );
}
